"use strict";

require("core-js/modules/es.object.to-string");

require("core-js/modules/es.promise");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.promiseFlow = void 0;

var _fp = require("lodash/fp");

var promiseFlow = function promiseFlow(func) {
  return function (promise) {
    return Promise.resolve(promise).then(func);
  };
};

exports.promiseFlow = promiseFlow;

var _default = function _default() {
  for (var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  return (0, _fp.flow)((0, _fp.map)(promiseFlow), _fp.flow)(funcs);
};

exports.default = _default;
//# sourceMappingURL=index.js.map